import React, { useState } from 'react';
import moment from 'moment';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { ReactComponent as IntakeFormCompletedIcon } from 'src/assets/svgs/intake-form-completed.svg';
import { ReactComponent as IntakeFormIncompletedIcon } from 'src/assets/svgs/intake-form-incompleted.svg';

import MemberSettingsPanel from './MemberProfilePanel';
import { CareFormModal } from './CareFormModal';

export interface IntakeForm {
  uuid: string;
  submitted: boolean;
  intakeFormQuestionResponses: Array<{
    questionName: string;
    questionResponseContent: string | string[];
    uuid: string;
  }>;
  completedBy: {
    firstName: string;
    lastName: string;
  };
  exitedAt: string | null;
  completedAt: string | null;
}

export enum CareFormSectionTestID {
  IntakeForm = 'CareFormSection.IntakeForm',
}

interface Props {
  intakeForm: IntakeForm;
  directDisplay?: boolean;
}

export const CareFormSection: React.FC<Props> = ({ intakeForm, directDisplay }) => {
  // An optional prop can be passed into the component so it starts with the care form displayed:
  const [careFormModalVisible, setCareFormModalVisible] = useState(!!directDisplay);
  const flags = useFlags();

  if (!intakeForm || flags?.hideCareFormSectionProfileDrawer) {
    return null;
  }

  const handleClick = () => {
    setCareFormModalVisible(true);
  };

  const Icon = intakeForm?.submitted ? IntakeFormCompletedIcon : IntakeFormIncompletedIcon;
  const completedDateFormatted =
    intakeForm?.completedAt &&
    moment(intakeForm?.completedAt, 'YYYY-MM-DD').format('MMMM DD, YYYY');
  const text = intakeForm?.submitted
    ? `Completed${completedDateFormatted ? ' - ' + completedDateFormatted : ''}`
    : 'Incomplete';

  return (
    <>
      <MemberSettingsPanel title="Care Form">
        <div
          className="mb-2 flex items-center cursor-pointer"
          onClick={handleClick}
          data-testid={CareFormSectionTestID.IntakeForm}
        >
          <Icon className="mr-2" />
          <p className="font-extrabold text-sm text-gray-800">{text}</p>
        </div>
      </MemberSettingsPanel>
      <CareFormModal
        visible={careFormModalVisible}
        onClose={() => setCareFormModalVisible(false)}
        intakeForm={intakeForm}
      />
    </>
  );
};
